import { v4 as uuidv4 } from "uuid";

const DIRECTION_NONE = "none";
const DIRECTION_HORIZONTAL = "horizontal";
const DIRECTION_VERTICAL = "vertical";
const DIRECTION_DIAGONAL_RIGHT_UP = "diagonal-right-up";
const DIRECTION_DIAGONAL_LEFT_UP = "diagonal-left-up";

const findAllMatches = (arr, letter) => {
    const matches = [];

    for (let i = 0; i < arr.length; i++) {
        const row = arr[i];

        for (let j = 0; j < row.length; j++) {
            const cell = row[j];

            if (cell === letter) {
                matches.push({ row: i, col: j });
            }
        }
    }

    return matches;
};

const getNeighboringCells = (arr, row, col, distance) => {
    const rows = arr.length;
    const cols = arr[0].length;

    const neighboringCells = [];

    for (let i = row - distance; i <= row + distance; i++) {
        for (let j = col - distance; j <= col + distance; j++) {
            if (i >= 0 && i < rows && j >= 0 && j < cols && !(i === row && j === col)) {
                neighboringCells.push({
                    value: arr[i][j],
                    row: i,
                    col: j,
                });
            }
        }
    }

    return neighboringCells;
};

function arePlacedClosely(array) {
    if (array.length <= 1) {
        return { closed: false, direction: DIRECTION_NONE };
    }

    array.sort((a, b) => {
        if (a.row !== b.row) {
            return a.row - b.row;
        } else {
            return a.col - b.col;
        }
    });

    // Remove duplicates from the sorted array
    const uniqueArray = [];
    for (let i = 0; i < array.length; i++) {
        if (i === 0 || array[i].row !== array[i - 1].row || array[i].col !== array[i - 1].col) {
            uniqueArray.push(array[i]);
        }
    }

    const isHorizontallyPlaced = () => {
        for (let i = 1; i < uniqueArray.length; i++) {
            const currentElement = uniqueArray[i];
            const previousElement = uniqueArray[i - 1];

            if (currentElement.row !== previousElement.row || currentElement.col !== previousElement.col + 1) {
                return false;
            }
        }
        return true;
    };

    const isVerticallyPlaced = () => {
        for (let i = 1; i < uniqueArray.length; i++) {
            const currentElement = uniqueArray[i];
            const previousElement = uniqueArray[i - 1];

            if (currentElement.col !== previousElement.col || currentElement.row !== previousElement.row + 1) {
                return false;
            }
        }
        return true;
    };

    const isDiagonallyPlaced = () => {
        if (uniqueArray.length <= 1) {
            // If there is only one or zero elements, they are considered placed closely horizontally.
            return { closed: true, direction: DIRECTION_HORIZONTAL };
        }

        const firstElement = uniqueArray[0];
        const secondElement = uniqueArray[1];

        const rowDiff = secondElement.row - firstElement.row;
        const colDiff = secondElement.col - firstElement.col;

        for (let i = 1; i < uniqueArray.length; i++) {
            const currentElement = uniqueArray[i];
            const previousElement = uniqueArray[i - 1];

            if (currentElement.row !== previousElement.row + rowDiff || currentElement.col !== previousElement.col + colDiff) {
                return false;
            }
        }

        if (rowDiff === 1 && colDiff === -1) {
            // Diagonal placement with right side up
            return { id: uuidv4(), closed: true, direction: DIRECTION_DIAGONAL_RIGHT_UP };
        } else if (rowDiff === 1 && colDiff === 1) {
            // Diagonal placement with left side up
            return { id: uuidv4(), closed: true, direction: DIRECTION_DIAGONAL_LEFT_UP };
        } else {
            return false;
        }
    };

    if (isHorizontallyPlaced()) {
        return { id: uuidv4(), closed: true, direction: DIRECTION_HORIZONTAL };
    } else if (isVerticallyPlaced()) {
        return { id: uuidv4(), closed: true, direction: DIRECTION_VERTICAL };
    } else {
        const diagonalPlacement = isDiagonallyPlaced();
        if (diagonalPlacement) {
            return diagonalPlacement;
        } else {
            return { id: uuidv4(), closed: false, direction: DIRECTION_NONE };
        }
    }
}

export { arePlacedClosely, DIRECTION_DIAGONAL_LEFT_UP, DIRECTION_DIAGONAL_RIGHT_UP, DIRECTION_HORIZONTAL, DIRECTION_VERTICAL, findAllMatches, getNeighboringCells };

